import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d8b8d92"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex flex-col justify-center items-center min-h-[calc(100vh-60px)] laptop:flex-row laptop:px-20 gap-20 laptop:gap-10 p-10",
  id: "contentArea"
}
const _hoisted_2 = ["src"]

import CustomButton from "@/components/Base/CustomButton.vue";
import {ref} from "vue";
import {ZavodyBtn} from "@/interfaces/interfaces";
import {CompetitionType} from "@/interfaces/enums";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const items = ref<Array<ZavodyBtn>>([
  {
    image: 'spolecky.jpg',
    name: CompetitionType.spolecky,
    path: '/vysledkySpolecneSkladby',
    btnColor: 'bg-green',
    bgColor: 'hover:bg-greenLight'
  } as ZavodyBtn,
  {
    image: 'jednotlivci.png',
    name: CompetitionType.jednotlivci,
    path: '/vysledkyJednotlivci',
    btnColor: 'bg-orange',
    bgColor: 'hover:bg-orangeLight'
  }as ZavodyBtn,
  {
    image: 'esg.jpg',
    name: CompetitionType.esg,
    path: '/vysledkyESG',
    btnColor: 'bg-blue',
    bgColor: 'hover:bg-blueLight'
  } as ZavodyBtn
])




return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        to: '/vysledky' + item.path,
        key: item.name,
        id: 'link-' + item.name,
        class: _normalizeClass(["w-[60%] rounded-2xl flex flex-col items-center justify-center hover:cursor-pointer ease-in-out transition transition-duration-100 hover:scale-105 laptop:bg-gray-100 laptop:p-5 laptop:w-auto laptop:space-y-10", item.bgColor])
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: 'obrazky/zavody/' + item.image,
            alt: "",
            class: "invisible h-0 flex flex-col justify-center items-center rounded-xl laptop:visible laptop:h-[300px]"
          }, null, 8, _hoisted_2),
          _createVNode(CustomButton, {
            value: item.name,
            "bg-color": item.btnColor,
            "text-color": "text-white",
            class: "w-full h-[70px] font-semibold text-lg laptop:w-auto laptop:h-auto laptop:text-base laptop:font-normal"
          }, null, 8, ["value", "bg-color"])
        ]),
        _: 2
      }, 1032, ["to", "id", "class"]))
    }), 128))
  ]))
}
}

})